document.addEventListener('DOMContentLoaded', () => {
    // 1) Helper: search across all *open* shadow roots
    function queryAllOpenShadow(selector, root = document) {
    const results = [...root.querySelectorAll(selector)];
    const hosts = [...root.querySelectorAll('*')].filter(el => el.shadowRoot);
    for (const host of hosts) {
        results.push(...queryAllOpenShadow(selector, host.shadowRoot));
    }
    return results;
    }

    // 3) Function to replace the benefits list
    function replaceRechargeBenefits(selected_option) {
        console.log(selected_option);
        let html = `<ul><li><p>Save 5%</p></li><li><p>Standard shipping</p></li><li><p>No commitment. Cancel anytime</p></li></ul>`;
        if(selected_option == "With the crew") {
            html = `<ul><li><p>Save 5%</p></li><li><p>Standard shipping with Free 4-packs</p></li><li><p>No commitment. Cancel anytime</p></li></ul>`;
        } else if(selected_option == "For the party") {
            html = `<ul><li><p>Save 5%</p></li><li><p>Free shipping with Free 4-packs</p></li><li><p>No commitment. Cancel anytime</p></li></ul>`;
        }
        
        const targets = queryAllOpenShadow('div[part="rc-benefits__list"]');
        targets.forEach(el => { el.innerHTML = html; });
    }

    // 4) Trigger on clicks to any .variant-option (event delegation)
    document.querySelectorAll('.variant-option').forEach((el) => {
        el.addEventListener('click', (e) => {
            // use currentTarget (the .variant-option), not e.target (could be a child)
            const text = e.currentTarget.querySelector('.uppercase')?.textContent.trim() || '';
            replaceRechargeBenefits(text);
        });
    });


    // (Optional) Support keyboard activation (Enter/Space) on focused .variant-option
    document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.variant-option')) {
        replaceRechargeBenefits();
    }
    });

});

(() => {
  // ========= CONFIG =========
  const MAIN_VARIANT_IDS = [40219789983802, 40219790016570];   // trigger variants
  const FREE_VARIANT_ID  = 40996734566458;                      // free product variant
  const POLL_MS = 800;

  // ========= HELPERS =========
  const getCart = () => fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());

  const addVariant = (variantId, qty) =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(r => r.ok ? r.json() : Promise.reject(r));

  const changeByKey = (lineItemKey, qty) =>
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineItemKey, quantity: qty })
    }).then(r => r.ok ? r.json() : Promise.reject(r));

  // Detect native subscription line items
  const isSubscription = (item) =>
    Boolean(item?.selling_plan || item?.selling_plan_allocation?.selling_plan?.id);
  async function refreshCartUI({ openDrawer } = { openDrawer: false }) {
    if (!window.$store) return;
    await window.$store.dispatch('cart/initCart').catch(()=>{});
    if (openDrawer) window.$store.dispatch('cart/show');
  }

  async function updateCartUI() {
    const cart = await getCart();
    let itemCount = cart.item_count;
    let cartSubtotal = cart.items_subtotal_price / 100;

    if(itemCount > 0) {
      if(document.querySelector(".open-cart div")) {
        document.querySelector(".open-cart div").innerText = itemCount;
      } else {
        let newDiv = document.createElement("div");
        newDiv.classList.add(
          "w-5",
          "h-5",
          "md:w-6",
          "md:h-6",
          "flex",
          "justify-center",
          "items-center",
          "bg-black",
          "text-white",
          "text-sm",
          "border",
          "border-white",
          "rounded-full",
          "absolute",
          "-top-2",
          "-right-2"
        );
        newDiv.innerText = itemCount;
        document.querySelector(".open-cart a").appendChild(newDiv);
      }
      if(document.querySelectorAll("#teleport-cart .giftbox-checkout")) {
        document.querySelectorAll("#teleport-cart .giftbox-checkout").forEach((item) => {
          item.innerText = item.innerText.replace(/(\p{Sc})\s*[\d.,]+/u, `$1${cartSubtotal}`);
        });
      }
    } else {
      if(document.querySelector(".open-cart div")) {
        document.querySelector(".open-cart div").remove();
      }
    }
  }

  let syncing = false;

  // returns true if cart mutated (free item added/updated/removed)
  async function syncFreeWithMain() {
    if (syncing) return false;
    syncing = true;
    let mutated = false;

    try {
      // EMERGENCY DISABLED - Free 4-pack automation disabled to prevent $0 orders
      return;
      
      const cart = await getCart();

      // Give 1 free 4-pack with ANY order (exclude the free 4-pack itself from count)
      const hasProducts = cart.items.some(i => i.id !== FREE_VARIANT_ID);
      const free = cart.items.find(i => i.id === FREE_VARIANT_ID);
      const targetQty = hasProducts ? 1 : 0;          // 1 free 4-pack if cart has products
      const currentQty = free ? (free.quantity || 0) : 0;

      if (targetQty !== currentQty) {
        if (free) {
          await changeByKey(free.key, targetQty);
          mutated = true;
        } else if (targetQty > 0) {
          await addVariant(FREE_VARIANT_ID, targetQty);
          mutated = true;
        }
      }
    } catch (err) {
      console.warn("[FreeItemSync] sync failed", err);
    } finally {
      syncing = false;
    }

    return mutated;
  }

  // ========= POLLING LOOP (every 800 ms) =========
  let ticking = false;
  setInterval(async () => {
    if (ticking) return;
    ticking = true;
    try {
      const changed = await syncFreeWithMain();
      if (changed) await refreshCartUI({ openDrawer: true });
    } finally {
      updateCartUI();
      ticking = false;
    }
  }, POLL_MS);

  // Initial pass
  (async () => {
    const changed = await syncFreeWithMain();
    if (changed) await refreshCartUI({ openDrawer: false });
  })();
})();

// ========= POSTSCRIPT FREE SHIPPING INTEGRATION =========
(function() {
  const FREE_SHIPPING_CODE = 'POSTSCRIPT-FREESHIP';
  const FREE_SHIPPING_KEY = 'postscript_free_shipping';
  
  // Check if user already has free shipping
  function hasFreeShipping() {
    return localStorage.getItem(FREE_SHIPPING_KEY) === 'true';
  }
  
  // Set free shipping flag and apply discount
  function setFreeShipping() {
    localStorage.setItem(FREE_SHIPPING_KEY, 'true');
    applyFreeShippingDiscount();
  }
  
  // Apply free shipping discount code to cart
  async function applyFreeShippingDiscount() {
    try {
      // First, get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check if discount is already applied
      if (cart.attributes && cart.attributes.discount === FREE_SHIPPING_CODE) {
        console.log('[Postscript] Free shipping discount already applied');
        return;
      }
      
      // Apply discount code
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'discount': FREE_SHIPPING_CODE,
            'postscript_signup': 'true'
          }
        })
      });
      
      if (updateResponse.ok) {
        console.log('[Postscript] Free shipping discount applied');
        // Redirect to checkout with discount code
        window.location.href = `/discount/${FREE_SHIPPING_CODE}?return_to=/cart`;
      }
    } catch (err) {
      console.error('[Postscript] Failed to apply free shipping:', err);
    }
  }
  
  // Listen for Postscript subscription events
  document.addEventListener('postscript:subscription', function(event) {
    console.log('[Postscript] Subscription event detected:', event.detail);
    
    if (!hasFreeShipping()) {
      setFreeShipping();
      console.log('[Postscript] Free shipping activated for new subscriber');
      
      // Show confirmation message
      if (typeof window.showNotification === 'function') {
        window.showNotification('Free shipping unlocked! 🎉');
      }
    }
  });
  
  // Check on page load if flag exists and we're on cart/checkout
  const isCartOrCheckout = window.location.pathname.includes('/cart') || 
                          window.location.pathname.includes('/checkout');
  if (hasFreeShipping() && isCartOrCheckout) {
    applyFreeShippingDiscount();
  }
})();

